export default "__VITE_ASSET__v0ZOHhAb__"